export const SIDEBAR_ID = 'sidebar';
